import { h, type FunctionalComponent } from 'vue'
import { NuxtLink } from '#components'

type Variant = 'primary' | 'quiet' | 'danger' | 'destructive' | 'ghost'

type Props = { variant?: Variant; to?: string; icon?: boolean; small?: boolean }

// Functional: buttons repeat in table rows and toolbars, so no instance state.
// Renders a NuxtLink when `to` is set, a <button> otherwise. Styles are the
// .btn rules in assets/css/main.css.
const AppButton: FunctionalComponent<Props> = (props, { slots }) => {
  const cls = ['btn', `btn-${props.variant ?? 'quiet'}`, { 'btn-icon': props.icon, 'btn-sm': props.small }]
  return props.to
    ? h(NuxtLink, { to: props.to, class: cls }, () => slots.default?.())
    : h('button', { type: 'button', class: cls }, slots.default?.())
}

AppButton.props = { variant: String, to: String, icon: Boolean, small: Boolean }

export default AppButton
